module.exports = __webpack_public_path__ + "02_long_gray.b8e65b4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/02_long_gray.png
// module id = +PPP
// module chunks = 0